import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import BarChartComponent from './Component';

import { MIN_BAR_CHART_HEIGHT } from './constants';

const BarChartContainer = props => {
  const [canvasWidth, setCanvasWidth] = useState(0);
  const [canvasHeight, setCanvasHeight] = useState(0);

  const containerRef = useRef(null);

  useEffect(() => {
    setCanvasWidth(
      containerRef.current.clientWidth
    );

    setCanvasHeight(Math.max(
      containerRef.current.clientHeight,
      MIN_BAR_CHART_HEIGHT
    ));
  }, [containerRef]);

  return (
    <div ref={containerRef} className="flex flex-grow">
      {canvasWidth && canvasHeight &&
      <BarChartComponent
        {...props}
        canvasWidth={canvasWidth}
        canvasHeight={canvasHeight}
      />
      }
    </div>
  );
};

BarChartContainer.propTypes = {
  bars: PropTypes.array.isRequired
};

export default BarChartContainer;
